module.exports = __webpack_public_path__ + "static/media/tie.ebb604e8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/projects/wardrober/src/tie.svg
// module id = 581
// module chunks = 0